module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/5_7cdef0cde678bf85e837038878a669fb.png";